import React from 'react'
import styled from 'styled-components'

import TakeAwayLineItemsContainer from 'components/dine-in/TakeAwayLineItemsContainer'
import GlobalCartLineItem from 'components/dine-in/GlobalCartLineItem'
import type { GlobalCart } from 'hooks/useGlobalCart'

interface GlobalCartLineItemTakeAwayProps {
  globalCart: GlobalCart
  buffetPackageName?: string
}

const GlobalCartLineItemTakeAway = ({ globalCart, buffetPackageName }: GlobalCartLineItemTakeAwayProps) => {
  return (
    <TakeAwayWrapper className="user-line-items-take-away-wrapper">
      <TakeAwayLineItemsContainer>
        <GlobalCartLineItem globalCart={globalCart} buffetPackageName={buffetPackageName} noPadding noBorderTop />
      </TakeAwayLineItemsContainer>
    </TakeAwayWrapper>
  )
}

export default GlobalCartLineItemTakeAway

const TakeAwayWrapper = styled.div`
  & + & {
    margin-top: ${({ theme }) => theme.spacing.XS};
  }

  &:last-child {
    margin-bottom: ${({ theme }) => theme.spacing.XL};
  }
`
